var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.isLogin),expression:"!isLogin"}],staticClass:"skeleton-box"},[(_vm.isLogin)?_c('VpPlayer',{ref:"VpPlayer",attrs:{"videoList":_vm.videoList},on:{"playbackFailed":_vm.handlePlaybackFailed,"startPlay":_vm.handleStartPlay,"onHandover":_vm.handleOnHandover}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }